import React, { useEffect } from 'react';
export const ImmigrationLawRedirect = () => {
  useEffect(() => {
    window.location.href = 'https://www.pigeonimmigration.com';
  }, []);
  return <div className="h-screen flex items-center justify-center bg-gradient-to-b from-[#f8faff] to-[#f0f5ff]" data-id="element-451">
      <p className="text-[#5A6376]" data-id="element-452">Redirecting to Pigeon Immigration...</p>
    </div>;
};
export const SubjectivitiesRedirect = () => {
  useEffect(() => {
    window.location.href = 'https://www.pigeonsubjectivities.com';
  }, []);
  return <div className="h-screen flex items-center justify-center bg-gradient-to-b from-[#f8faff] to-[#f0f5ff]" data-id="element-453">
      <p className="text-[#5A6376]" data-id="element-454">Redirecting to Pigeon Subjectivities...</p>
    </div>;
};